import React from "react";
import styles from "../EventsPage.module.css";
import iconMap from "../../../../assets/Icons/event-map.svg";
import iconCalendar from "../../../../assets/Icons/event-calendar.svg";
import iconLight from "../../../../assets/Icons/Icon_Light.svg";

export function PreviousEventCard({ imageUrl, title, location, dateLabel }) {
  return (
    <article className={styles.gridCard}>
      <div className={styles.gridCardImageWrap}>
        {imageUrl ? (
          <img className={styles.gridCardImage} src={imageUrl} alt="" loading="lazy" />
        ) : (
          <img className={styles.gridCardImage} src={iconLight} alt="" loading="lazy" />
        )}
      </div>
      <div className={styles.gridCardBody}>
        <h3 className={styles.gridCardTitle}>{title}</h3>
        <div className={styles.gridCardMeta}>
          <div className={styles.gridMetaRow}>
            <img className={styles.gridMetaIcon} src={iconMap} alt="" aria-hidden />
            <p className={styles.gridMetaText}>{location}</p>
          </div>
          <div className={`${styles.gridMetaRow} ${styles.gridMetaRowDate}`}>
            <img className={styles.gridMetaIcon} src={iconCalendar} alt="" aria-hidden />
            <p className={styles.gridMetaText}>{dateLabel}</p>
          </div>
        </div>
      </div>
    </article>
  );
}
